<div class="py-2 flex flex-col space-y-2 align-middle flex-wrap md:space-x-4 md:flex-row md:space-y-0">
  <button mat-raised-button
    color="warn"
    routerLink="/admin"
    target="_blank">
    Course Order</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/coupon"
    target="_blank">
    coupons</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/users"
    target="_blank">
    Users</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/courses"
    target="_blank">
    Courses</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/items"
    target="_blank">
    Items</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/create-questions"
    target="_blank">
    Questions</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/create-exam"
    target="_blank">
    Exam</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/create-test"
    target="_blank">
    Add test</button>
  <button mat-raised-button
    color="warn"
    routerLink="/admin/admin-notification"
    target="_blank">
    Notification</button>
</div>